import Text from '@cartwhl/ui/base/Text';
import FileIcon from '@cartwhl/ui/icons/FileIcon';

export default function FilesListEmptyState() {
  return (
    <div className="flex items-center gap-1">
      <FileIcon className="text-blue" />
      <Text variant="studio/body/medium/sm">
        <span className="text-blue">Select image(s), video(s), or .zip file(s)</span>{' '}
        <span className="text-gray-60">or drop them here</span>
      </Text>
    </div>
  );
}
